import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Tooltip } from 'components';
import * as styles from './NewLocation.scss';
var NewLocationFormStep3 = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewLocationFormStep3, _Component);

  var _super = _createSuper(NewLocationFormStep3);

  function NewLocationFormStep3() {
    var _this;

    _classCallCheck(this, NewLocationFormStep3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "getChecklistItems", function () {
      var _this$props = _this.props,
          contractInfo = _this$props.contractInfo,
          formValues = _this$props.formValues;
      var items = [];
      var useExistingLicense = false;
      var partnerName = contractInfo ? contractInfo.contract.businessName : 'Partner';
      var newLocationName = formValues && formValues.orgDetails.businessName && formValues.orgDetails.businessName !== '' ? formValues.orgDetails.businessName : 'New Location';
      var partnerPaysLicense = formValues.locationBillingInfo.licenseFeeBillTo === 'partner';
      var partnerPaysAds = formValues.locationBillingInfo.adsBillTo === 'partner';
      var locationPaysLicense = formValues.locationBillingInfo.licenseFeeBillTo === 'location';
      var locationPaysAds = formValues.locationBillingInfo.adsBillTo === 'location';

      if (locationPaysLicense && locationPaysAds) {
        items.push("".concat(newLocationName, "'s ").concat(formValues.cc.cardDetails ? formValues.cc.cardDetails.brand : 'card', " ending in ").concat(formValues.cc.cardDetails ? formValues.cc.cardDetails.last4 : '****', " will be charged ").concat(_this.formatCurrency(parseInt(formValues.orgConfig.managementFee, 10) + parseInt(formValues.orgConfig.adsBudget, 10)), " on the ").concat(moment().format('Do'), " of each month for the Monthly License Fee and Monthly Ads Amount as a recurring transaction."));
      }

      if (locationPaysLicense && !locationPaysAds) {
        items.push("".concat(newLocationName, "'s ").concat(formValues.cc.cardDetails ? formValues.cc.cardDetails.brand : 'card', " ending in ").concat(formValues.cc.cardDetails ? formValues.cc.cardDetails.last4 : '****', " will be charged ").concat(_this.formatCurrency(formValues.orgConfig.managementFee), " on the ").concat(moment().format('Do'), " of each month for the Monthly License Fee as a recurring transaction."));
      }

      if (locationPaysAds && !locationPaysLicense) {
        items.push("".concat(newLocationName, "'s ").concat(formValues.cc.cardDetails ? formValues.cc.cardDetails.brand : 'card', " ending in ").concat(formValues.cc.cardDetails ? formValues.cc.cardDetails.last4 : '****', " will be charged ").concat(_this.formatCurrency(formValues.orgConfig.adsBudget), " on the ").concat(moment().format('Do'), " of each month for the Monthly Ads Amount as a recurring transaction."));
      }

      if (partnerPaysLicense && !useExistingLicense) {
        items.push("Your next invoice will include a one time, prorated charge for ".concat(newLocationName, "'s Monthly License Fee to cover the time between now and your next billing date.\nYou will be billed ").concat(_this.formatCurrency(parseInt(formValues.orgConfig.managementFee)), " per month on behalf of this location."));
      }

      if (partnerPaysAds) {
        items.push("Your recurring monthly bill will include the Monthly Ads Amount of ".concat(_this.formatCurrency(formValues.orgConfig.adsBudget), " for ").concat(newLocationName, " starting on your next billing date."));
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "renderChecklistItem", function (text, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.step3Item,
        key: "checklistItem_".concat(index)
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-android-checkmark-circle ".concat(styles.step3ItemIcon),
        style: {
          color: _this.props.theme.colors.secondaryColor
        }
      }), text);
    });

    return _this;
  }

  _createClass(NewLocationFormStep3, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          contractInfo = _this$props2.contractInfo,
          formValues = _this$props2.formValues,
          totals = _this$props2.totals;
      var _this$props$formValue = this.props.formValues,
          orgConfig = _this$props$formValue.orgConfig,
          orgDetails = _this$props$formValue.orgDetails;
      var newLocationName = formValues && formValues.orgDetails.businessName && formValues.orgDetails.businessName !== '' ? formValues.orgDetails.businessName : 'New Location';
      var locationCCDetails = formValues.cc.cardDetails ? formValues.cc.cardDetails : {
        brand: 'card',
        last4: '****'
      };
      var checklistItems = this.getChecklistItems();
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 52
        }
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.summarySection
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.step3Header
      }, "Billing Details Confirmation"), checklistItems.map(function (item, index) {
        return _this2.renderChecklistItem(item, index);
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.step3Item
      }, "Click Finish below to add ", newLocationName, "."), this.props.formValues.cardChargeError && this.props.formValues.cardChargeError !== '' && /*#__PURE__*/React.createElement("div", {
        className: styles.errorBox,
        style: {
          marginTop: 30
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.stripeError
      }, this.props.formValues.cardChargeError)));
    }
  }]);

  return NewLocationFormStep3;
}(Component)) || _class);
export { NewLocationFormStep3 as default };